import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { IoClose } from "react-icons/io5";
import { postsup, useFetchData } from '../hooks/useFetchData';
import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function Submodal({ open, setOpen }) {
  const [selectedPackage, setSelectedPackage] = React.useState("");
  const handleClose = () => setOpen(false);
  const [numbers, setNumbers] = React.useState("")
  const { data } = useFetchData(`${process.env.REACT_APP_API_URL}getUserByPhone?mobile=${numbers}`);
  const { data: packages } = useFetchData(`${process.env.REACT_APP_API_URL}packages`)
  const handleuser = (event) => {
    const value = event.target.value.replace(/\D/g, ""); // removes non-digits
    setNumbers(value);
    console.log(value);
  };
  console.log("pack", packages?.data);

  const handlePackageChange = (event) => {
    setSelectedPackage(event.target.value);
    console.log(event.target.value);
  };
    const mutation = useMutation({
      mutationFn: postsup,
      onSuccess: (data) => {
        console.log("Posted successfully", data.data.post.post_reference);
       
      },
      onError: (error) => {
        console.error("Posting failed", error.message);
      },
    });
const handlesup =() =>{
  const today = new Date().toISOString().split('T')[0];
  const formData = new FormData();
  console.log("package_id", packages?.data[0].id);
  
      // Append coordinates
      formData.append("start_date", today);
      formData.append("user_id",data?.data?.id );
      formData.append("package_id", selectedPackage || packages?.data[0].id);
      
    
      // Call mutation
      mutation.mutate(formData, {
        onSuccess: (data) => {        
          console.log("Success!");
        },
        onError: (error) => {        
          toast(error.message);
          console.error("Error occurred");
        },
        
      });
      handleClose()
}

  return (
    <div>
      <Button variant="outlined" onClick={() => setOpen(true)}>new subscripition</Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        
        <Fade in={open}>
          <Box sx={style}>         
            <Grid container spacing={2}>
              <Grid size={11}></Grid>
              <Grid size={1}> <IoClose style={{fontSize:"20px"}} onClick={handleClose}/></Grid>
              <Grid size={6}>
                <label>phone number </label>
              </Grid>
              <Grid size={6}>
                <TextField onChange={handleuser} value={numbers} id="outlined-basic" label="phone number" variant="outlined" />
              </Grid>

              <Grid size={6}>
                <label>name</label>
              </Grid>
              <Grid size={6}>
                <h5>{data?.data?.name}</h5>
              </Grid>
              <Grid size={6}>
                <label>package</label>
              </Grid>
              <Grid size={6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">package</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedPackage}
                    onChange={handlePackageChange}
                    label="Age"

                  >
                    {packages?.data?.map((pack) =>
                      <MenuItem value={pack?.id}>{pack?.name}</MenuItem>
                    )}

                  </Select>
                </FormControl>
              </Grid>
               <Grid size={10}></Grid>
                 <Grid size={2}>
                  {data?.data?.id &&<Button variant="outlined" onClick={handlesup}>send</Button>}
                 </Grid>
            </Grid>

          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
